'use client';

import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { RoleOptions } from '@paladin-monorepo/common';
import { useAuth } from '@/lib/auth';

interface RequireRolesProps {
  roles: Array<(keyof typeof RoleOptions) | string>;
  children: React.ReactNode;
}

export function RequireRoles({ roles, children }: RequireRolesProps) {
  const location = useLocation();
  const { user, isLoading } = useAuth({ middleware: 'auth', redirectTo: '/auth/login', tmp: 'RequireRoles' });

  if (isLoading) return null;

  if (!user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  const isAllowed = roles.includes(user.role);
  if (!isAllowed) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default RequireRoles;


